import { render } from "./InputDataView.vue?vue&type=template&id=160d1822&scoped=true"
import script from "./InputDataView.vue?vue&type=script&lang=js"
export * from "./InputDataView.vue?vue&type=script&lang=js"

import "./InputDataView.vue?vue&type=style&index=0&id=160d1822&scoped=true&lang=css"

import exportComponent from "/root/workspace/web--ming-pan_4MVO/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160d1822"]])

export default __exports__